/* esm.sh - applesauce-common@5.2.0/operations/blossom */
export * from "/*applesauce-common@5.2.0/esnext/operations/blossom.mjs";
